import React from "react";
import CalendarComponent from "../../components/ui/calendar/Calendar";

const calendar = () => {
  return (
    <div>
      <h1>My Calendar</h1>
      <CalendarComponent />
    </div>
  );
};

export default calendar;
